module.exports = __webpack_public_path__ + "768d8a2f0965d44dd6c8ab474e596107.svg";